import slider from "./components/slider";
import websaSelect from "./components/websaSelect";

export default {
  slider: slider,
  websaSelect: websaSelect
};
